export default {
      id: "logo-technics-usage",
      viewBox: "0 0 366 52",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#logo-technics",
      toString: function () {
        return this.url;
      }
    }